import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, mediaUrl } from "../lib/api";
import { usePlayer } from "../context/PlayerContext";
import { Avatar } from "../components/Avatar";
import { StyleTag, Loader, Card } from "../components/ui-bits";
import { Music, Play, Pause } from "lucide-react";

export default function BeatmakerProfile() {
  const { id } = useParams();
  const { track, playing, play } = usePlayer();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/profiles/beatmaker/${id}`).then((r) => setData(r.data)); }, [id]);
  if (!data) return <Loader />;
  const u = data.user;
  return (
    <div className="max-w-2xl mx-auto">
      <Card className="p-6 mb-6">
        <div className="flex items-center gap-4">
          <Avatar user={u} size={72} />
          <div>
            <p className="font-display font-bold text-xl">@{u.pseudo}</p>
            <div className="flex flex-wrap gap-1.5 mt-2">{(u.styles || []).map((s) => <StyleTag key={s}>{s}</StyleTag>)}</div>
            <p className="text-xs font-mono text-violet-300 mt-2">{data.production_count} productions</p>
          </div>
        </div>
        {u.description && <p className="text-sm text-zinc-300 mt-4 leading-relaxed">{u.description}</p>}
      </Card>

      <h2 className="text-lg font-display font-bold mb-4">Productions publiques</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {data.productions.map((p) => {
          const cov = mediaUrl(p, "image");
          const isCur = track && track.id === `pub-${p.id}`;
          return (
            <Card key={p.id} className="p-3 flex items-center gap-3">
              <button onClick={() => play({ id: `pub-${p.id}`, title: p.title, subtitle: `@${u.pseudo}`, production: p, cover: cov })}
                className="relative w-12 h-12 rounded-lg overflow-hidden shrink-0">
                {cov ? <img src={cov} alt="" className="w-full h-full object-cover" /> : <div className="w-full h-full bg-gradient-to-br from-violet-700 to-purple-900 flex items-center justify-center"><Music size={16} /></div>}
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">{isCur && playing ? <Pause size={16} fill="white" /> : <Play size={16} fill="white" className="ml-0.5" />}</div>
              </button>
              <div className="min-w-0">
                <p className="text-sm font-medium truncate">{p.title}</p>
                <p className="text-[11px] font-mono text-zinc-500">{[p.style, p.bpm && `${p.bpm} BPM`].filter(Boolean).join(" · ")}</p>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
